<script setup>
import MediaBox  from '@/components/common/MediaBox.vue'
import Side from '@/components/common/Sidebanner.vue';
</script>
<template>
<v-card flat tile>
<v-card-text>
      <v-list
       dense>
        <v-list-item
          v-for="item,index in items"
          :key="item.title"
          link
          @click="menu_link(index)"
        >
          <v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
</v-card-text>
<v-card-text>
<MediaBox />
</v-card-text>
<v-card-text>
<Side />
</v-card-text>
</v-card>
</template>
<script>
  export default {
    data () {
      return {
        items: [
          { title: '新規追加'    , icon: 'mdi-plus' },
          { title: '配信日で追加', icon: 'mdi-calendar-plus' },
          { title: 'スケジュール管理', icon: 'mdi-calendar-clock' },
          { title: '商材情報登録', icon: 'mdi-gift-outline' },
        ],
      }
    },
    methods : {
        menu_link(index){
			this.$emit("menu",{'index':index});
        },
    },
  }
</script>

